import { HGAnyRecord, HGAnyRecordData } from "@/common/types";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "../sheet";
import RecordForm from "./RecordForm";
import { PendingMediaFile } from "./MediaInput";
import { PropsWithChildren } from "react";
import { globalReloader } from "@/providers/dbRecordsLoader";

type RecordButtonProps = PropsWithChildren &
  React.ComponentProps<typeof Sheet> & {
    title: string;
    record: HGAnyRecord | HGAnyRecordData;
    initialPending?: PendingMediaFile[];
  };

export default function RecordSheet({
  record,
  title,
  children,
  initialPending,
  ...sheetProps
}: RecordButtonProps) {
  return (
    <Sheet {...sheetProps}>
      {children && <SheetTrigger asChild>{children}</SheetTrigger>}
      <SheetContent className="max-sm:inset-0 max-sm:w-full max-sm:border-l-0 sm:w-[380px] sm:max-w-[380px] flex flex-col overflow-hidden">
        <SheetHeader className="px-5 pt-[18px] pb-3 border-b flex-shrink-0">
          <SheetTitle
            className="text-[18px] font-semibold text-foreground"
            style={{ fontFamily: "var(--font-serif)" }}
          >
            {title}
          </SheetTitle>
        </SheetHeader>
        <div className="flex-grow min-h-0">
          <RecordForm
            record={record}
            initialPending={initialPending}
            onSubmit={() => {
              globalReloader.reload();
              sheetProps.onOpenChange?.(false);
            }}
          />
        </div>
      </SheetContent>
    </Sheet>
  );
}
